import React from 'react'

import { connect } from 'react-redux'
import EdicionData from '../../../Utils/components/EdicionData'
import { actualizarVentaAExportador } from '../../actions'
import EdicionVentaExportador from './EdicionVentaExportador'

function EditarVenta (props) {
  const { data, actualizarVentaAExportador } = props

  return (

    <>
      <EdicionData
        actualizar={actualizarVentaAExportador}
        titulo='Modificar venta a exportador'
        contenido={<EdicionVentaExportador data={data} />}
      />
    </>
  )
}

const mapActionsToProps = {
  actualizarVentaAExportador
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(EditarVenta)
